// extracted by mini-css-extract-plugin
module.exports = {"hero_slider":"HeroSection_hero_slider___Evwz","prev_icon":"HeroSection_prev_icon__CIVCE","next_icon":"HeroSection_next_icon__8gJBJ"};